export default "__VITE_ASSET__5PYW0$n1__"